import { render, staticRenderFns } from "./BaseInputText.vue?vue&type=template&id=2bca74f7&scoped=true&"
import script from "./BaseInputText.vue?vue&type=script&lang=js&"
export * from "./BaseInputText.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputText.vue?vue&type=style&index=0&id=2bca74f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca74f7",
  null
  
)

export default component.exports